import { gql } from '@apollo/client';

export const GET_CREATIVE_REVIEW_STATUSES = gql`
  query GET_CREATIVE_REVIEW_STATUSES {
    getCreativeReviewsStatusV5
  }
`;
